import React from 'react';
import { IBrand } from '@/models/IBrand';
import IRanking from '@/models/viewModels/IRanking';
import styles from './branding.module.scss';

type Props = {
  brand: IBrand;
  highlightRanking: IRanking;
};

export default function Branding({ brand, highlightRanking }: Props) {
  return (
    <section id="uni-branding" className={`${styles.branding} mb-4 d-flex`}>
      <div className={`${styles.logo}`}>
        {brand.logo && <img id="uni-logo" src={brand.logo} alt={`${brand.name} Logo`} />}
      </div>
      <div className="ms-md-4 ms-0">
        {brand.name && (
          <h1 id="uni-name" className={`${styles.brand_name} mb-md-2`}>
            {brand.name}
          </h1>
        )}
        {highlightRanking && (
          <p className={styles.highlight_ranking} id="uni-highlight-ranking">
            Ranked #{highlightRanking.rank} {highlightRanking.source} {highlightRanking.year}
          </p>
        )}
      </div>
    </section>
  );
}
